export default "__VITE_ASSET__5f14f6fb__"